import { useCallback } from 'react'

import { useAsync } from 'core/ui/hooks/useAsync'

import { useConfigContext } from 'config/ui/ConfigContext'

import {
  getPaginatedRfpHistory,
  type GetPaginatedRfpHistoryParams,
} from '../../use-cases/getPaginatedRfpHistory'
import { getRfpHistory } from '../../use-cases/getRfpHistory'

export function useProposalHistory() {
  const enablePaginatedRfpList = useConfigContext().enablePaginatedRfpList.toBoolean()
  const { call, result, status } = useAsync(getRfpHistory)

  const {
    call: callPaginated,
    result: resultPaginated,
    status: statusPaginated,
  } = useAsync(getPaginatedRfpHistory)

  const fetchRfpHistory = useCallback(
    async ({ signal }: AbortController) => call({ signal }),
    [call]
  )

  const fetchPaginatedRfpHistory = useCallback(
    async (params: GetPaginatedRfpHistoryParams, { signal }: AbortController) =>
      callPaginated(params, { signal }),
    [callPaginated]
  )

  const rfpHistory = enablePaginatedRfpList ? resultPaginated?.results : result
  const rfpHistoryStatus = enablePaginatedRfpList ? statusPaginated : status

  return {
    rfpHistory: rfpHistory ?? [],
    rfpHistoryStatus,
    totalCount: resultPaginated?.count,
    fetchRfpHistory,
    fetchPaginatedRfpHistory,
  }
}
